export enum ExportDataFilter {
  ALL = 'all',
  ACCEPTED = 'accepted',
  ANNOTATED = 'annotated',
  CONFIG_ONLY = 'configOnly',
}
